/** @module utils/percent/formatPercent */
export default function formatPercent(number, defaultVal = null, options = {}) {
  if (isNaN(String(number))) return defaultVal;
  return `${Number(number).toLocaleString('en-US', options)}%`;
}
